/**
 * Calculates the date based on a specified time range.
 *
 * @param {TimeRange} period - The time range for which the start date is calculated.
 * Valid values are '1W', '1M', '1Y', and 'ALL'.
 * @return {string | null} The calculated date as an ISO string for '1W', '1M', or '1Y',
 * or null if the time period is 'ALL' or not recognized.
 */
export const getIsoDateStringFromTimeRange= (period: TimeRange): string | null => {
    const now = new Date();
    const date = getDateForTimeRange(period, now);
    return date.toISOString();
}

/**
 * Calculates the date based on a specified time range.
 *
 * @param {TimeRange} period - The time range for which the start date is calculated.
 * Valid values are '1W', '1M', '1Y', and 'ALL'.
 * @param now - The current date.
 * @return {string | null} The calculated date for '1W', '1M', or '1Y',
 * or null if the time period is 'ALL' or not recognized.
 */
export function getDateForTimeRange(period: TimeRange, now: Date): Date | null {
    switch (period) {
        case '1W': {
            const d = new Date(now);
            d.setDate(d.getDate() - 7);
            return d;
        }
        case '1M': {
            const d = new Date(now);
            d.setDate(d.getDate() - 30);
            return d;
        }
        case '1Y': {
            const d = new Date(now);
            d.setDate(d.getDate() - 365);
            return d;
        }
        case 'ALL':
        default:
            return null;
    }
}
